export default __webpack_public_path__ + "static/media/horacio.91a7e2b9.jpg";